export interface RowWindowInput {
  scrollTop: number;
  viewportHeightPx: number;
  rowHeightPx: number;
  rowCount: number;
  overscan: number;
}

export interface RowWindow {
  start: number;
  end: number;
  topSpacerHeight: number;
  bottomSpacerHeight: number;
}

export const rowWindow = ({
  scrollTop,
  viewportHeightPx,
  rowHeightPx,
  rowCount,
  overscan,
}: RowWindowInput): RowWindow => {
  const rowsInViewport = Math.ceil(viewportHeightPx / rowHeightPx);
  const firstVisibleRow = Math.floor(Math.max(0, scrollTop) / rowHeightPx);

  const start = Math.min(rowCount, Math.max(0, firstVisibleRow - overscan));
  const end = Math.min(
    rowCount,
    Math.max(start, firstVisibleRow + rowsInViewport + overscan)
  );

  return {
    start,
    end,
    topSpacerHeight: start * rowHeightPx,
    bottomSpacerHeight: (rowCount - end) * rowHeightPx,
  };
};
